<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
  import * as echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import resize from './mixins/resize'

  export default {
    mixins: [resize],
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '350px'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      chartData: {
        type: Object,
        required: false
      },

    },
    data() {
      return {
        chart: null
      }
    },
    watch: {

      chartData: {
        deep: true,
        handler(val) {
          this.setOptions(val)
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(this.chartData)
      },
      setOptions({ data, xAxis } = {}) {
        if (!xAxis || !data) return;

        const enableZoom = xAxis.length > 10;

        this.chart.setOption({
          xAxis: [{
            type: 'category',
            data: xAxis,
            axisTick: { alignWithLabel: true },
            axisLabel: {
              interval: 0,
              fontSize: 10,
              color: '#fff',
              formatter: function (value) {
                return value.match(/.{1,7}/g)?.join('\n') || value;
              }
            },
            axisLine: {
              lineStyle: { color: '#4F7A9E' }
            }
          }],
          grid: {
            top: 10,
            left: 0,
            right: 0,
            bottom: enableZoom ? 60 : 0, // 有滚动条时底部留空间
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
            padding: [5, 10]
          },
          yAxis: {
            axisTick: { show: false },
            axisLabel: { color: '#fff' },
            axisLine: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#4F7A9E',
                type: 'solid',
                width: 1
              }
            }
          },
          dataZoom: enableZoom ? [
            {
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              bottom: 10,
              height: 20,
              borderColor: 'rgba(0,0,0,0)',
              backgroundColor: '#e2e2e2',
              fillerColor: 'rgba(0, 189, 219, 0.4)',
              handleStyle: {
                color: '#00BDDB'
              },
              textStyle: {
                color: '#fff'
              },
              start: 0,
              end: Math.floor(100 * 10 / xAxis.length) // 初始显示前10个
            }
          ] : [],
          series: [{
            name: '人',
            type: 'bar',
            data: data,
            smooth: true,
            barWidth: 20,
            barGap: '20%',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: '#CBE7FF' },
                  { offset: 1, color: '#00BDDB' }
                ]
              }
            },
            animationDuration: 2800,
            animationEasing: 'cubicInOut'
          }]
        });
      }
    }
  }
</script>